export default __webpack_public_path__ + "static/media/sign_nav.2205fe18.svg";